import Vue from 'vue';
import OwlCarousel from 'v-owl-carousel'

Vue.component('carousel', OwlCarousel);
Vue.component('comments-home', require('../components/index/CommentsHome').default);

Vue.config.productionTip = false;
Vue.config.devtools = true;

if (document.getElementById("vue-comments-home")) {
    new Vue({
        el: '#vue-comments-home',
    });
}